import React  from 'react';
import styles from './MoneyInput.scss';
import CSSModules from "react-css-modules";
import PropTypes from "prop-types";
import NumberFormat from 'react-number-format';
import {FormattedMessage} from "react-intl";



@CSSModules(styles, {allowMultiple: true})
class MoneyInput extends React.Component{

  constructor(props) {
    super(props);

  }

  isValBelowMax(values){
    const { formattedValue, floatValue } = values;
    return formattedValue === "" || floatValue < 10000000;
  }
  render(){
    return (
      <div styleName={'inputContainer'} >
      <label styleName={"inputLabel"}>
        <FormattedMessage id={this.props.labelId}/>
    </label>
      <NumberFormat allowNegative={false} onFocus={this.props.onFocus} data-at={this.props.dataAt} isAllowed={this.isValBelowMax} value={this.props.value} placeholder="$" onValueChange={(valObj) => this.props.onChange(valObj.floatValue)} styleName={'numericInput'}  thousandsGroupStyle={'thousand'} prefix='$ ' thousandSeparator={true}/>
        {
          this.props.helperTextId &&
        <div styleName={'helperText'}>
         <FormattedMessage id={this.props.helperTextId}/>
        </div>
        }
      </div>
    );
  }
}

MoneyInput.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.number,
  validator: PropTypes.func,
  helperTextId: PropTypes.string,
  labelId : PropTypes.string,
  dataAt : PropTypes.string
};

export default MoneyInput;



// WEBPACK FOOTER //
// ./src/components/common/Input/MoneyInput.js